"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
function formatDate(input, format) {
    if (!input || !format) {
        return '';
    }
    return (0, dayjs_1.default)(input).format(format);
}
exports.formatDate = formatDate;
